import { create } from "zustand";

import { TUserAccociatedBU } from "@type/api/businessUnit/types";
import { TGetUserAccessRightReq } from "@type/api/management/types";
import { TBooleanRecord } from "types/index";

export type TBusinessUnit = Omit<
  TUserAccociatedBU,
  "roleName" | "totalMember"
> & {
  slug: string;
};

type TBussinessUnitStore = {
  isLoading: boolean;
  isLoadingBUList: boolean;
  selectedBU?: TBusinessUnit;
  buAccessRight?: TBooleanRecord;
  mapBUList?: Record<string, TBusinessUnit>;
  appAccessRight?: TBooleanRecord;
  appAccessRightKey?: Array<string | TGetUserAccessRightReq | undefined>;
  onSetMapBUList: (mapBUList: Record<string, TBusinessUnit>) => void;
  onSetLoading: (isLoading: boolean) => void;
  onSetLoadingBUList: (isLoadingBUList: boolean) => void;
  onSetSelectedBU: (bu: TBusinessUnit) => void;
  onSetBUAccessRight: (access: TBooleanRecord) => void;
  onSetAppAccessRight: (access: TBooleanRecord) => void;
  onSetAppAccessRightKey: (
    key: Array<string | TGetUserAccessRightReq | undefined>
  ) => void;
};

export const useBusinessUnitStore = create<TBussinessUnitStore>((set) => ({
  isLoading: true,
  isLoadingBUList: true,
  selectedBU: undefined,
  buAccessRight: undefined,
  appAccessRight: undefined,
  appAccessRightKey: undefined,
  onSetLoading: (isLoading) => {
    set({ isLoading });
  },
  onSetLoadingBUList: (isLoadingBUList) => {
    set({ isLoadingBUList });
  },
  onSetSelectedBU: (selectedBU) => {
    set({ selectedBU });
  },
  onSetBUAccessRight: (buAccessRight) => {
    set({ buAccessRight });
  },
  onSetMapBUList: (mapBUList) => {
    set({ mapBUList });
  },
  onSetAppAccessRight: (appAccessRight) => {
    set({ appAccessRight });
  },
  onSetAppAccessRightKey: (appAccessRightKey) => {
    set({ appAccessRightKey });
  },
}));
